import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-messageWithTextModal-popup',
  templateUrl: './message-with-text-popup.component.html',
  styleUrls: ['./message-with-text-popup.component.sass']
})
export class MessageWithTextPopup implements OnInit {
  titleText: string;
  bodyText: string;

  constructor() { }

  public ngOnInit() {
  }

  public show(title, text){
    $('#messageWithTextModalTitleText').text(title)
    $('#messageWithTextModalBodyText').text(text)
    $('#messageWithTextModal').show();
  }

  public hide(){
    $('#messageWithTextModal').hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/modal-window/message-with-text-popup/message-with-text-popup.component.ts